module.exports = __webpack_public_path__ + "components/home-header/static/header-6--medium-89c19ecdfb962b445aa253ece2aa5f81.jpg";